import { Component, Input, Output,
         OnChanges, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-plain-dropdown',
  templateUrl: './plain-dropdown.component.html',
  styleUrls: ['./plain-dropdown.component.less']
})

export class PlainDropdownComponent {
  @Input() rightAlign: boolean = false;
  @Input() open: boolean = false;
  @Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  public close() {
    this.open = false
    this.openChange.emit(this.open);
  }

  public toggle() {
    this.open = !this.open;
    this.openChange.emit(this.open);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/plain-dropdown/plain-dropdown.component.ts